import asyncRoute from '../../lib/asyncRoute';
import React from 'react';

export const UserPg01 = asyncRoute(() => import('./UserInfoController.js'));
export const UserPg02 = asyncRoute(() => import('./UserBodyController.js'));
export const UserPg03 = asyncRoute(() => import('./UserRankController.js'));
export const UserPg04 = asyncRoute(() => import('./UserHealthController.js'));
export const UserPg05 = asyncRoute(() => import('./UserMissionController.js'));
export const UserPg06 = asyncRoute(() => import('./UserChatController.js'));
